<template>
  <a-tooltip slot="addonAfter" placement="right" overlayClassName="l8-tooltip">
  <template slot="title">
    <p v-if="data.description" v-html="data.description"></p>
    <img v-if="data.img" :src="data.img">
  </template>
  <a-icon class="tooltip" type="info-circle"></a-icon>
</a-tooltip>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>
